<template>
  <div class="header media-header-height">
    <div class="left auto-hide" :title="schoolName" v-text="schoolName">
    </div>
    <div class="center" v-text="zone && zone.name">
    </div>
    <div class="right text-right">
      <div class="return" v-if="isHidden">
        <a :href="$config.v1">返回旧版</a>
      </div>
      <div>
        <el-badge :value="value" :max="99" @click.native.stop="showMessage" class="notice">
          <img src="../assets/images/home/notify.png" style="height: 24px"/>
           <transition name="fade">
              <dl class="notice-list" :class="{'notice-lists': notice.data && !notice.data.length}" v-show="isShow"  @click.stop>
                <dt class="list-menu">
                  <span :class="{'active': type === 0}" @click="tabSwitch(0)">异常<i :class="{'notice-flog': isOdds}"></i></span>
                  <span :class="{'active': type === 1}" @click="tabSwitch(1)">通知<i :class="{'notice-flog ': isNotices}"></i></span>
                </dt>
                <dd class="has-list" v-show="notice.data && notice.data.length" :class="{'isnotice': type}">
                  <div class="list" :state="item.isRead" @click="goDetail(item._id, item.isRead, item)" v-for="(item, index) in notice.data" :key="index">
                    <div class="item">
                      <p class="tit">{{!type ? '[监控室-'+ item.nodeName +'] 已断电...' : '[设备-'+item.nodeName+'] 已上线...'}}</p>
                      <p class="data">{{comm.dateFormat(item.createdAt, 'yyyy-MM-dd HH:mm:ss')}}</p>
                    </div>
                  </div>
                  <div class="list-btn" @click="goNotice(type)">查看所有消息</div>
                  <div class="list-btn" @click="remove(type)">清空{{type === 0 ? '异常' : '通知'}}</div>
                </dd>
                <dd class="no-list" v-show="notice.data && !notice.data.length">
                    <p>当前暂无信息</p>
                </dd>
              </dl>
            </transition>
        </el-badge>
      </div>
      <div>
        <img src="../assets/images/home/js-tx.png" class="user" @click="toUser()"/>
        <!--<img src="../assets/images/home/arrow_down.png"/>-->
      </div>
    </div>
  </div>
</template>

<script>
import { Message } from 'element-ui'
import { mapState } from 'vuex'
import notice from '../model/notice'
import basic from '@/model/zone'
import comm from '../assets/lib/comm'
import cache from '@/assets/lib/cache'
/*  */
export default {
  name: 'Header',
  data () {
    return {
      isShow: false,
      isNotice: false,
      type: 0, // 0: 异常 1：通知
      notice: {},
      comm,
      where: {
        zoneId: '',
        page: 1,
        perPage: 3,
        deviceType: '',
        type: 0 // 0 表示异常  1 表示通知
      },
      isOdds: false,
      isNotices: false,
      value: 0,
      time: null
    }
  },
  destroyed () {
    clearTimeout(this.time)
    this.time = null
    clearTimeout(this.times)
    this.times = null
  },
  computed: {
    ...mapState(['zone']),
    isHidden () {
      // 入口从12-31号开始封闭
      const expDate = (new Date('2019/05/28 00:00:00')).getTime()
      if (new Date().getTime() > expDate) {
        return false
      }
      return true
    },
    schoolName () {
      if (this.zone && this.zone.tree) {
        return this.zone.tree[0].name
      } else {
        return (this.zone && this.zone.name) || ''
      }
    },
    isShows () {
      return this.notice.data && this.notice.data.some(item => !item.isRead)
    }
  },
  async mounted () {
    window.addEventListener('click', () => { this.isShow = false })
    await this.info()
    this.where.zoneId = this.zone.id
    await this.getStatus()
    // 定时获取未读通知数量
    this.unread()
  },
  methods: {
    // 获取初始信息
    async info () {
      await basic.getBasicInfo()
    },
    // 定时捞总的未读通知数
    async unread () {
      let self = this
      clearTimeout(this.time)
      this.time = null
      clearTimeout(this.times)
      this.times = null
      function time () {
        self.time = setTimeout(async () => {
          self.value = await notice.unReadTotal({ zoneId: self.zone.id })
          self.times = setTimeout(time, self.$config.timing)
        }, self.$config.timing)
      }
      time()
    },
    // 处理是否有未读通知红点标识
    async getStatus () {
      let temp = Object.assign({}, this.where)
      // 异常
      temp.type = 0
      let odd = await notice.getNotice({ ...temp })
      // 通知
      temp.type = 1
      let notic = await notice.getNotice({ ...temp })
      this.isOdds = odd.data && odd.data.some(item => !item.isRead)
      this.isNotices = notic.data && notic.data.some(item => !item.isRead)
    },
    // 获取通知信息
    async getNotice () {
      this.notice = await notice.getNotice({ ...this.where })
    },
    showChildren () {
      // Message.success('功能正在开发中...')
    },
    showMessage () {
      this.isShow = !this.isShow
      this.getNotice()
      // Message.success('暂无系统消息')
    },
    toUser () {
      this.$router.push('/user')
    },
    // 查看所有消息
    goNotice (type) {
      this.$router.push({
        path: `/notice/${type}`
      })
    },
    // 切换tab
    tabSwitch (type) {
      this.type = type
      this.where.type = type
      this.getNotice()
    },
    // 跳转到详情页
    async goDetail (noticeId, isRead, items) {
      // 处理设置已读
      if (!isRead) {
        await notice.markedRead({ noticeId, type: this.type })
      }
      // 防止刷新采取storage
      cache.setCache('noticeContent', items)
      this.$router.push({
        name: `noticeDetail`,
        params: {
          id: noticeId,
          content: items
        },
        query: {
          type: this.type
        }
      })
    },
    async remove (type) {
      let result = await notice.remove({ zoneId: this.zone.id, type })
      if (result.code === 1) {
        Message.success('清空成功！')
        this.getNotice()
        this.getStatus()
      }
    }
  }
}
</script>
<style lang="less">
.right {
  .el-badge__content {
    font-size: 10px;
    padding: 0 6px;
    cursor: pointer;
  }
}
</style>
<style scoped lang="less">
@import "../assets/less/base";
@import "../assets/less/mixin";

.header {
  height: 45px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 20px;
  position: fixed;
  top: 0;
  z-index: 2;
  width: 100%;
  background-color: @base-white;
  .return {
    margin-right: 18px;
  }
  img {
    cursor: pointer;
  }
  .user {
    margin-left: 30px;
    height: 25px
  }
  .center {
    font-size: 17px;
    font-weight: 600;
    color: rgba(38, 38, 38, 1);
  }
  .right {
    > div {
      display: inline-block;
    }
    width: 150px;
    padding-top: 8px
  }
  .left {
    width: 150px;
    font-size: 13px;
    font-weight: 400;
    color: rgba(89, 89, 89, 1);
  }
}
.notice {
  text-align: left;
  position: relative;
  top: -6px;
  .notice-list {
    position: absolute;
    top: 35px;
    right: -18px;
    width: 240px;
    padding: 0;
    background: #fff;
    box-shadow:0px 4px 19px 1px rgba(5,5,5,0.08);
    border-radius:8px;
    transition: all 3s;
  }
  .notice-lists{
    min-height: 240px;
  }
  .list-menu {
    display: flex;
    height: 41px;
    line-height: 41px;
    text-align: center;
    flex-flow: row nowrap;
    font-size: 15px;
    span {
      flex: 1;
      border-bottom: 1px solid #EEEFF0;
    }
    .active {
      border-color: #39D474;
      color: #39D474;

    }
    .notice-flog {
      position: relative;
      top: -8px;
      left: 4px;
      display: inline-block;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: #F16C69;
    }
  }
  .has-list {
    margin: 0;
  }
  .list {
    padding: 15px 12px;
    display: flex;
    &:before{
      display: block;
      content: '';
      width: 32px;
      height: 32px;
      border-radius: 50%;
      background: url("../assets/images/home/inf-unusual.png") no-repeat;
      background-size: cover;
      margin-right: 12px;
    }
    &:after {
      position: absolute;
      right: 12px;
      display: block;
      content: '';
      width: 8px;
      height: 8px;
      border-radius: 50%;
      margin-left: 6px;
      background: #F16C69;
      margin-top: 20px;
    }
    p{
      line-height: 22px;
      color: #595959;
      margin: 0;
      flex: 1;
      max-width: 156px;
    }
    .tit {
      font-size: 15px;
      .text-overflow(1);
    }
    .data {
      font-size: 12px;
      color: #989898;
    }
    // 已读和未读的按时区别
    &[state="1"] {
      &:before{
        opacity: .25;
      }
      &:after{
        display: none
      }
      & .tit {
        color: #989898;
      }
      & .data {
        color: #ACACAC;
      }
    }
  }
  .isnotice {
    .list {
      &:before {
        background: url("../assets/images/home/inf-notice.png") no-repeat;
        background-size: cover;
      }
    }
  }
  .no-list {
    margin: 0;
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    text-align: center;
    justify-content: center;
    height: 190px;
    &:before{
      display: block;
      content: "";
      width: 62px;
      height: 54px;
      background: url("../assets/images/home/inf-emptystate.png") no-repeat;
      background-size: cover;
    }
    p{
      font-size: 14px;
      color: #989898;
    }
  }
  .list-btn {
    height: 45px;
    line-height: 45px;
    text-align: center;
    color:#262626;
    border-top: 1px solid #EEEFF0;
    font-size: 13px;
    color: #262626
  }
  .noticeShow {
    height: auto;
    min-height: 240px;
  }
/* 可以设置不同的进入和离开动画 */
  /* 设置持续时间和动画函数 */
  .fade-enter {
    opacity: 0;
  }
  .fade-enter-active {
    transition: all .3s ease;
    opacity: 1;
  }
  .fade-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .fade-enter, .fade-leave-to
  /* .slide-fade-leave-active for below version 2.1.8 */ {
    transform: translateX(20px);
    opacity: 0;
  }
}
</style>
